import type { ReactNode } from "react";
import React from "react";

import { InteractiveSurface } from "./InteractiveSurface";
import "./kit.css";

export type T_IconButtonSize = "compact" | "regular";
export type T_IconButtonVariant = "filled" | "quiet";

export type T_IconButtonProps = {
  ariaControls?: string;
  ariaExpanded?: boolean;
  ariaLabel: string;
  disabled?: boolean;
  icon: ReactNode;
  onClick: () => void;
  size?: T_IconButtonSize;
  variant?: T_IconButtonVariant;
};

/**
 * Canonical icon-only action — web mirror of the mobile IconButton. Press
 * state uses fill, never an outline.
 */
export function IconButton({
  ariaControls,
  ariaExpanded,
  ariaLabel,
  disabled = false,
  icon,
  onClick,
  size = "regular",
  variant = "filled",
}: T_IconButtonProps) {
  return (
    <InteractiveSurface
      ariaControls={ariaControls}
      ariaExpanded={ariaExpanded}
      ariaLabel={ariaLabel}
      backgroundColor={
        variant === "filled" ? "var(--lattice-dark-grey-dark-7)" : "transparent"
      }
      className={[
        "lk-icon-button",
        size === "compact"
          ? "lk-icon-button--compact"
          : "lk-icon-button--regular",
        disabled ? "lk-icon-button--disabled" : "",
      ]
        .filter(Boolean)
        .join(" ")}
      disabled={disabled}
      onClick={onClick}
      pressedBackgroundColor="var(--lattice-dark-grey-dark-6)"
    >
      {icon}
    </InteractiveSurface>
  );
}
